import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { openPopup } from "../../../store/popupSlice"

export default function LandingItalyChoose({ data }) {
  const dispatch = useDispatch();
  return (
    <>
      <section className="land2-choose-area">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="land2-choose-head">
                <h3 className="heading center-heading">{data.titlePart1} <span className="gradiant-color"> {data.titlePart2}</span></h3>
                <div className="row justify-content-center">
                  <div className="col-lg-7 text-center">
                    <label>{data.subTitle}</label>
                    <p>{data.desc}</p>
                  </div>
                </div>
              </div>
            </div>

            {data.boxes && data.boxes.map((box, index) => (
              <div className="col-lg-4 col-md-6" key={index}>
                <div className="land2-choose-box">
                  <span><img loading="lazy" src={box.image} alt="icon" className="img-responsive" /></span>
                  <h4>{box.title}</h4>
                  <p>{box.desc}</p>
                </div>
              </div>
            ))}

            <div className="col-lg-12">
              <div className="land2-rider-butn land2-choose-btns">
                <h4>{data.ctaTitle}</h4>
                <button onClick={() => dispatch(openPopup())} className="default-btn">{data.cta1}</button>
                <Link to={"/features/taxi-software"}><button className="default-white">{data.cta2}</button></Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
